import { functions } from "../app/firebase.config";
import { httpsCallable } from "./firebaseCallable";

const callable = (name) => httpsCallable(functions, name);

const normalizeList = (data, fallbackKey) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data[fallbackKey])) return data[fallbackKey];
  return [];
};

export const fetchOakSubjects = async () => {
  const result = await callable("getOakSubjects")();
  return normalizeList(result.data, "subjects");
};

export const fetchOakKeyStages = async () => {
  const result = await callable("getOakKeyStages")();
  return normalizeList(result.data, "keyStages");
};

export const searchOakLessons = async (payload) => {
  const result = await callable("searchOakLessons")(payload);
  return normalizeList(result.data, "lessons");
};

export const fetchOakLessonDetails = async (lessonSlug) => {
  const result = await callable("getOakLessonDetails")({ lessonSlug });
  return result.data || {};
};
